const swatchStyles =
"font-size: 12px;"+
"font-weight: 400;"+
"line-height: 32px;"+
"text-align: center;"+
"display: inline-block;"+
"margin: 14px 0 0 0 ;"+
"min-width: 15px;"+
"height: 15px;"+
"border-radius: 2px;"

const getAllUrlParameterValues = (parameter) => {
  let url = new URL(window.location.href); // Use the current URL
  let params = new URLSearchParams(url.search); // Parse the query string
  let values = params.getAll(parameter); // Get all values associated with 'parameter name'
  return values
}

const getSelectedCharacteristics = () => {
  let characteristics = []
  $('#filter-features_filters input').each(function() { 
    if($(this).is(':checked')) {
      characteristics.push($(this).val())
    }
  })
  return characteristics
}

const buildCharacteristicsIconsUpsell = (data) => {
    const productTags = Object.values(data.tags);
    let currentCharacteristics = getSelectedCharacteristics();
    currentCharacteristics = currentCharacteristics.length > 0 ? currentCharacteristics : getAllUrlParameterValues('filter.p.tag');
    let characteristicsImagesReorder = [];
    let charactericsOrderKeys = Object.keys(characteristicsImages);
    currentCharacteristics.forEach(key => {
      let currentKey = key
      if (key == "Sound Absorption" || key == "Sound Blocking"){
        currentKey = "Best " +  key;
      }
      if (charactericsOrderKeys.includes(currentKey)) {
        characteristicsImagesReorder[currentKey] = characteristicsImages[currentKey];
        characteristicsImagesReorder.length++;
      }
     });
     charactericsOrderKeys.forEach( key => {
      if (!currentCharacteristics.includes(key)) {
        characteristicsImagesReorder[key] = characteristicsImages[key];
        characteristicsImagesReorder.length++;
      }
     });    
    charactericsOrderKeys =  Object.keys(characteristicsImagesReorder);
    // characteristicsImages is base for displaying the icons based on the configuration done in theme settings
    let html = '';
    html = '<div class="characteristics">';
    html += '<div class="characteristics-icons"><ul style="display:flex">';
    let count = 0;
    let maxItems = window.innerWidth >= 425 && window.innerWidth <= 1024 ? 4 : 6;
    for (var i = 0; i < characteristicsImagesReorder.length; i++) {
      let currentKey = charactericsOrderKeys[i];
      if (count == maxItems) {
        break;
      } else if (count < maxItems && productTags.includes(currentKey)) {
        html += `
          <li class="characteristic-item">
            <img class="tag-icon" src="${ characteristicsImagesReorder[currentKey] }"/>
            <span class="tooltip-label">${ currentKey.replaceAll(' ','&#160;') }</span>
          </li>`;
        count++;
      }
    }
    html += '</ul></div></div>';
    return html;
  };
  const buildProductColorSwatchesUpsell = (colorArr) =>{
    let countColors = 0;
    let countExtraColors = 0;
    let colorHtml = `<ul class="custom-color-swatch-list">`;
    colorArr.forEach(color => {
      const colorClass = color.includes("Unfinished") ? "unfinished-field-paintable" : color.toLowerCase().replace(/ /g, '-');
      const applyBorder = 
      color.toLowerCase().includes('white') || color.toLowerCase().includes('standard')
        ? '#5e7183'
        : '#ffff';
      if (countColors < 6) {  
        colorHtml += `
          <li class="item-color compare-item swatch-item swatch-element swatchLbl color lazyloaded" aria-label="color:${ color }">
            <span class="swt${colorClass}" style="border: solid 1px ${applyBorder}; ${swatchStyles}"></span>
            <span class="tooltip-label"><p class="color-title">${color}</p></span>
          </li>`;
        countColors ++;
      }
      else{
        countExtraColors ++;
      }
    });
    if(countExtraColors != 0){
      colorHtml += `<span class="extra-colors">+${countExtraColors}</span>`;
    }
    colorHtml += `</ul>`;
    
    return colorHtml;
  };
  const getColorOptions = (items) => {
    let color_options = items.filter( option => option.name === 'Color');
    return color_options.length > 0 ? color_options[0]?.values : ['White'];
  }
  